import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionPanel,
  AccordionItem,
  Heading,
  Stack,
} from "@chakra-ui/react";

export default function QASection() {
  return (
    <Stack bg="#f7f7f7" py={10} alignItems="center" gap={6}>
      <Heading
        fontSize={{ base: "24px", md: "31px" }}
        fontWeight={"semibold"}
        py={6}
      >
        Q&amp;A
      </Heading>
      <Accordion allowToggle w={{ base: "90%", lg: "780px" }}>
        <AccordionItem
          alignItems={"center"}
          border="1px"
          borderColor="inherit"
          borderRadius={10}
          my={4}
        >
          <AccordionButton
            borderRadius={10}
            bg={{ base: "white" }}
            _hover={{ bg: { base: "white" } }}
            justifyContent="space-between"
            alignItems="center"
          >
            <Heading fontWeight={"semibold"} fontSize={{base:"13px",md:"20px"}} p={2}>
              What Can I Sell?
            </Heading>
            <AccordionIcon />
          </AccordionButton>

          <AccordionPanel
            pb={4}
            bg="white"
            borderRadius={"0px 0px 10px 10px"}
            borderTop="1px"
            borderColor="inherit"
            fontSize={{base:"13px",md:"20px"}}
          >
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim
            ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
            aliquip ex ea commodo consequat.
          </AccordionPanel>
        </AccordionItem>
        <AccordionItem
          alignItems={"center"}
          border="1px"
          borderColor="inherit"
          borderRadius={10}
          my={4}
        >
          <AccordionButton
            borderRadius={10}
            bg={{ base: "white" }}
            _hover={{ bg: { base: "white" } }}
            justifyContent="space-between"
            alignItems="center"
          >
            <Heading fontWeight={"semibold"} fontSize={{base:"13px",md:"20px"}} p={2}>
              How do I get paid
            </Heading>
            <AccordionIcon />
          </AccordionButton>

          <AccordionPanel
            pb={4}
            bg="white"
            borderRadius={"0px 0px 10px 10px"}
            borderTop="1px"
            borderColor="inherit"
            fontSize={{base:"13px",md:"20px"}}
          >
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim
            ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
            aliquip ex ea commodo consequat.
          </AccordionPanel>
        </AccordionItem>
        <AccordionItem
          alignItems={"center"}
          border="1px"
          borderColor="inherit"
          borderRadius={10}
          my={4}
        >
          <AccordionButton
            borderRadius={10}
            bg={{ base: "white" }}
            _hover={{ bg: { base: "white" } }}
            justifyContent="space-between"
            alignItems="center"
          >
            <Heading fontWeight={"semibold"} fontSize={{base:"13px",md:"20px"}} p={2}>
              How much money can I make?
            </Heading>
            <AccordionIcon />
          </AccordionButton>

          <AccordionPanel
            pb={4}
            bg="white"
            borderRadius={"0px 0px 10px 10px"}
            borderTop="1px"
            borderColor="inherit"
            fontSize={{base:"12px",md:"18px"}}
          >
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim
            ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
            aliquip ex ea commodo consequat.
          </AccordionPanel>
        </AccordionItem>
      </Accordion>
    </Stack>
  );
}
